import React from "react";
import Title from "../../new-components/title/Title";
import HeaderInner from "../../Components/HeaderInner";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { TbMobiledata, TbWorld } from "react-icons/tb";
import { MdOutlineDateRange } from "react-icons/md";
import { IoIosPricetag } from "react-icons/io";
import { Button } from "react-bootstrap";

const E_SimOptions = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const rawPath = location.pathname;
  const { t, i18n } = useTranslation();

  const room_uuid = rawPath.split("/")[1];
  const { company_id, type } = useParams();
  const lang = localStorage.getItem("lang");
  const new_design = localStorage.getItem("new_design");
  const theme = new_design === "true";
  const selectedRegion = location.state?.region;

  return (
    <div className={`${theme && "food"} ${lang === "AR" && "arabic"}`}>
      {theme ? (
        <Title title={t("eSIM")} />
      ) : (
        <HeaderInner headerName={t("eSIM")} />
      )}
      <main className="box_food image_services home-main bg-white back-white">
        {selectedRegion?.operators?.length > 0 ? (
          selectedRegion.operators.flatMap((operator, operatorIndex) =>
            operator.packages?.map((pkg, pkgIndex) => (
              <div
                key={`${operatorIndex}-${pkgIndex}`}
                className="sim-details-card"
              >
                {/* Operator Name */}
                <p
                  style={{
                    fontWeight: "bold",
                    fontSize: "18px",
                    marginBottom: "12px",
                  }}
                >
                  {operator.title}
                </p>

                {/* Coverage */}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "10px",
                  }}
                >
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <TbWorld style={{ marginRight: "6px" }} />
                    <span>{t("Coverage")}</span>
                  </div>
                  <span>{selectedRegion.title}</span>
                </div>

                {/* Data */}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "10px",
                  }}
                >
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <TbMobiledata style={{ marginRight: "6px" }} />
                    <span>{t("Data")}</span>
                  </div>
                  <span>{pkg.data}</span>
                </div>

                {/* Validity */}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "10px",
                  }}
                >
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <MdOutlineDateRange style={{ marginRight: "6px" }} />
                    <span>{t("Validity")}</span>
                  </div>
                  <span>
                    {pkg.day} {t("Days")}
                  </span>
                </div>

                {/* Price */}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <IoIosPricetag style={{ marginRight: "6px" }} />
                    <span>{t("Price")}</span>
                  </div>
                  <span>{pkg.retail_price}</span>
                </div>

                <Button
                  style={{ marginTop: "20px" }}
                  className="reg-btn big"
                  onClick={() =>
                    navigate(
                      `/${room_uuid}/sims/${company_id}/${type}/options/details`,
                      { state: { pkg, operator } }
                    )
                  }
                >
                  {t("Details")}
                </Button>
              </div>
            ))
          )
        ) : (
          <div className="text-center p-4">{t("No packages available.")}</div>
        )}
      </main>
    </div>
  );
};

export default E_SimOptions;
